export class ColorPaletteEntity {
  constructor(
    public readonly textColor: string,
    public readonly backgroundColor: string,
    public readonly buttonColor: string,
  ) {}
}
